<template>
  <div class="hero">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-9">
            <div class="title is-1">
              南極観測隊ウォークビュー
            </div>
          </div>
          <div class="column is-3">
            <div class="subtitle is-4">
              <a class="button is-large is-3" href="pdf/VRAntarctic_manual.pdf" target="_blank">
                使い方
              </a>
            </div>
          </div>
        </div>
        <hr>
        <div class="subtitle is-4">
        南極観測隊員になって基地や「しらせ」を見てみよう
        </div>
        <div class="main-contents">
          <div class="content-title subtitle is-2">
            南極観測船「しらせ」ウォークビュー
          </div>
          <router-link :to="{ name: 'view', params: { id: startNumber.shirase }}">
            <img class="shirase" src="asset/shirase.jpeg" alt="しらせ">
          </router-link>
          <div class="subtitle is-4">
            「しらせ」は年に一回、日本と南極を往復します。観測を行いながら観測隊員と荷物を南極まで運ぶのが仕事です。「しらせ」の中で観測隊の暮らすスペースを実際に回ってみましょう。
          </div>
          <router-link :to="{ name: 'view', params: { id: startNumber.shirase }}" class="button is-link is-large is-3">
            南極観測船「しらせ」ウォークビュー
          </router-link>
        </div>

        <div class="main-contents">
          <div class="content-title subtitle is-2">
            昭和基地ウォークビュー
          </div>
          <router-link :to="{ name: 'view', params: { id: startNumber.east }}">
            <img class="syowa" src="asset/syowa.jpeg" alt="昭和基地">
          </router-link>
          <div class="subtitle is-4">
            昭和基地は隊員が南極で観測活動を行うための日本の主要基地です。毎年隊員が入れ替わり、半世紀を超えて維持、管理、運用を続けています。観測隊員になった気持ちで昭和基地の主要部を回ってみましょう。
          </div>
          <router-link :to="{ name: 'view', params: { id: startNumber.east }}" class="button is-link is-large is-3">
            昭和基地ウォークビュー
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {startNumber} from './param/index.js'

export default {
  data() {
    return {
      startNumber,
    }
  },
  created() {
if( process.env.NODE_ENV=='development' ) {
  window.Top = this
}
  },
}
</script>

<style scoped lang="scss">
.main-contents {
  display: flex;
  flex-direction: column;
  margin-top: 4rem;

  .shirase {
    margin-right: 1rem;
    width: calc( ( 100% - 2rem ) / 3 * 2 );
  }
  .content-title {
    color: hsl(217, 71%, 35%);
  }

  .button {
    margin-bottom: 1rem;
  }
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  .button {
    font-size: 2.5rem;
    white-space: normal;
    height: auto;
  }
  .main-contents {
  }
}

@media screen and (max-width: 1344px) {
}

@media screen and (max-width: 1152px) {
  .title.is-1 {
    font-size: 2.8rem;
  }
  .subtitle.is-2 {
    font-size: 1.7rem;
  }
  .button.is-3 {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 960px) {
  .title.is-1 {
    font-size: 2.2rem;
  }
  .subtitle.is-2 {
    font-size: 1.8rem;
  }
  .button.is-3 {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 768px) {
  .title.is-1 {
    font-size: 2rem;
  }
  .subtitle.is-2 {
    font-size: 1.5rem;
  }
  .button.is-3 {
    font-size: 1.3rem;
  }
  .main-contents {
    flex-direction: column-reverse;

    .map {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-height: none;

      .svalbird {
        width: calc( ( 80% - 2rem ) );
      }
      .na {
        width: calc( ( 60% - 2rem ) );
      }
    }
  }
}
</style>
